import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { useGlobalContext } from "../GlobalContext";

const ListRoleHalaman = () => {
  const { api, isReady } = useGlobalContext();
  const [datatabel, setDataTabel] = useState([]);
  const [role, setRole] = useState([]);
  const [halaman, setHal] = useState([]);
  const [menu, setMenu] = useState([]);
  const [selectedMenu, setSelectedMenu] = useState('');
  const [selectedRole, setSelectedRole] = useState('');
  const [modalOpen, setModalOpen] = useState(false);
  const [modalEditOpen, setModalEditOpen] = useState(false);
  const [newData, setNewData] = useState({ kode_role: '', kode_hal: '', status: true });
  const [editData, setEditData] = useState({ kode_role: '', kode_hal: '', status: true });

  // 🔎 state untuk pencarian
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    if (isReady) {
      getMenu();
      getRole();
      getHal();
    }
  }, [isReady]);

  useEffect(() => {
    if (selectedRole) {
      getHalEnable(selectedRole);
    } else {
      setDataTabel([]);
    }
  }, [selectedRole]);

  useEffect(() => {
    if (modalOpen && selectedRole) {
      setNewData(prev => ({ ...prev, kode_role: selectedRole }));
    }
  }, [modalOpen, selectedRole]);

  const getMenu = async () => {
    try {
      const response = await api.get('/api/setup/menu');
      setMenu(response.data);
    } catch (error) {
      console.error("Gagal mengambil data menu:", error.response?.data || error.message);
      setMenu([]);
    }
  };

  const filteredHalaman = halaman.filter(
    (item) => String(item.menu) === String(selectedMenu)
  );

  const getHalEnable = async (koderole) => {
    try {
      const response = await api.get(`/api/setup/rolehalaman/${koderole || ''}`);
      setDataTabel(response.data || []);
    } catch (error) {
      console.error("Gagal mengambil data:", error);
    }
  };

  const getHal = async () => {
    try {
      const response = await api.get('/api/setup/halaman');
      setHal(response.data || []);
    } catch (error) {
      console.error("Gagal mengambil data halaman:", error);
    }
  };

  const getRole = async () => {
    try {
      const response = await api.get('/api/setup/role');
      setRole(response.data || []);
    } catch (error) {
      console.error("Gagal mengambil role:", error);
    }
  };

  const handleChange = (e, isEdit = false) => {    
    const { name, value, type, checked } = e.target;
    const val = type === 'checkbox' ? checked : value;

    if (isEdit) {
      setEditData(prev => ({ ...prev, [name]: val }));
    } else {
      setNewData(prev => ({ ...prev, [name]: val }));
    }
  };

  const handleAdd = async () => {
    try {   
      await api.post('/api/setup/rolehalaman', newData);
      setModalOpen(false);
      setNewData({ kode_role: '', kode_hal: '', status: true });
      getHalEnable(newData.kode_role);
    } catch (error) {
      console.error("Gagal menambah data:", error);
    }
  };

  const handleEdit = async () => {
    try {
      await api.patch(`/api/setup/rolehalaman`, editData);
      setModalEditOpen(false);
      getHalEnable(selectedRole);
    } catch (error) {
      console.error("Gagal mengedit data:", error);
    }
  };

  const deleteData = async (kode_role, kode_hal) => {
    if (window.confirm("Yakin hapus data ini?")) {
      try {
        await api.delete(`/api/setup/rolehalaman/${kode_role}/${kode_hal}`);
        getHalEnable(kode_role);
      } catch (error) {
        console.error("Gagal menghapus data:", error);
      }
    }
  };

  const openAddModal = () => {
    setNewData({ kode_role: '', kode_hal: '', status: true });
    setModalOpen(true);
  };

  const openEditModal = (kode_role, kode_hal,status) => {
    const selected = datatabel.find(r => r.kode_role === kode_role && r.kode_hal === kode_hal);
    if (selected) {
      setEditData({ ...selected, status: selected.status === 'true' ? true : false });
      setModalEditOpen(true);
    }
  };

  const columns = [
    {
      name: 'No',
      selector: (row, index) => index + 1,
      sortable: true,
      width: '80px',
      center: true,
    },
    {
      name: 'Menu',
      selector: row => row.menu,
      sortable: true,
      width: '120px',
      center: true,
    },
    {
      name: 'Sub Menu',
      selector: row => row.halaman,
      sortable: true,
      grow: 2, 
    },
    {
      name: 'Status',
      selector: row => row.status === 'true' ? 'Aktif' : 'Tidak Aktif',
      sortable: true,
      width: '120px',
      center: true,
    },
    {
      name: 'Aksi',
      cell: row => (
        <>
          <button className="btn btn-sm btn-info me-1" onClick={() => openEditModal(row.kode_role, row.kode_hal)}>Edit</button>
          <button className="btn btn-sm btn-danger" onClick={() => deleteData(row.kode_role, row.kode_hal)}>Hapus</button>
        </>
      ),
      width: '160px',
      center: true,
    }
  ];


  const filteredData = datatabel.filter(item =>
    item.menu?.toLowerCase().includes(searchText.toLowerCase()) ||
    item.halaman?.toLowerCase().includes(searchText.toLowerCase()) ||
    (item.status === 'true' ? 'aktif' : 'tidak aktif').includes(searchText.toLowerCase())
  );

  return (
    <div className="card shadow-sm">
      <div className="card-header">
        <div className="d-flex justify-content-end align-items-center mb-2">
          <button
            className="btn btn-primary"
            style={{ fontSize: "14px", padding: "6px 14px" }}
            onClick={openAddModal}
          >
          Tambah Data
         </button>
        </div>
        <div className="mb-2">
          <label>Role</label>
          <select className="form-control form-control-md" style={{ maxWidth: '300px' }} value={selectedRole} onChange={(e) => setSelectedRole(e.target.value)}>
            <option value="">-- Semua Role --</option>
            {role.map((item, index) => (
              <option key={index} value={item.kode_role}>{item.keterangan}</option>
            ))}
          </select>
        </div>
        <div className="card-body">
        <div className="mb-2 d-flex justify-content-end">
          <input
            type="text"
            className="form-control form-control-sm"
            style={{ maxWidth: "200px" }}
            placeholder="Cari Menu/Sub Menu..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
          </div>
        </div>
      <div className="card-body">
        <DataTable
          columns={columns}
          data={filteredData}
          pagination
          striped
          dense
          highlightOnHover
          responsive
          customStyles={{
            table: {
              style: {
                border: '1px solid #dee2e6', // border luar
              },
            },
            headRow: {
              style: {
                backgroundColor: '#fdfdfdff',
                borderBottom: '2px solid #dee2e6',
              },
            },
            headCells: {
              style: {
                fontWeight: 'bold',
                fontSize: '16px',
                backgroundColor: '#ffffffff',
                padding: '10px 12px',
                borderRight: '1px solid #dee2e6',
              },
              
            },
            rows: {
              style: {
                borderBottom: '1px solid #ffffffff',
              },
            },
           cells: {
            style: {
              borderRight: '1px solid #dee2e6',
              padding: '6px 8px', // lebih kecil dari sebelumnya
              fontSize: '14px',
            },
          },
          }}
          className="table table-bordered"
        />
      </div>        
      {/* Modal Tambah */}
      {modalOpen && (
        <div className="modal show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-md" role="document">
            <div className="modal-content shadow">
              <div className="modal-header">
                <h5 className="modal-title">Tambah Role Halaman</h5>
                <button className="btn-close" onClick={() => setModalOpen(false)} />
              </div>
              <div className="modal-body">
               <div className="form-group">
                <label>Kode Role</label>
                <input
                  className="form-control"
                  name="kode_role"
                  value={newData.kode_role}
                  readOnly
                />
              </div>
              <div className="form-group">
                <label>Menu</label>
                <select
                  className="form-control"
                  value={newData.selectedMenu}
                  onChange={(e) => {
                    setSelectedMenu(e.target.value);
                    setNewData({ ...newData, kode_hal: '' }); // reset pilihan halaman saat menu berubah
                  }}
                >
                  <option value="">-- Pilih Menu --</option>
                  {menu.map((item) => (
                    <option key={item.kode} value={item.kode}>
                      {item.kode} - {item.menu}
                    </option>
                  ))}
                </select>
              </div>

              {/* Dropdown Kode Halaman */}
              <div className="form-group">
                <label>Kode Halaman</label>
                <select
                  className="form-control"
                  name="kode_hal"
                  value={newData.kode_hal}
                  onChange={handleChange}
                  disabled={!selectedMenu}
                >
                  <option value="">-- Pilih Kode Halaman --</option>
                  {filteredHalaman.map((item) => (
                    <option key={item.kode} value={item.kode}>
                      {item.kode} - {item.halaman}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group form-check">
                <input
                type="checkbox"
                className="form-check-input"
                name="status"
                checked={newData.status === true}
                onChange={handleChange}
                />
                <label className="form-check-label">Aktif</label>
              </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setModalOpen(false)}>Tutup</button>
                <button className="btn btn-primary" onClick={handleAdd}>Simpan</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal Edit */}
      {modalEditOpen && (
        <div className="modal fade show d-block" style={{ display: 'block' }} aria-modal="true">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Edit Role Halaman</h5>
                <button className="btn-close" onClick={() => setModalEditOpen(false)} />
              </div>
              <div className="modal-body">
                <div className="form-group">
                  <label>Kode Role</label>
                  <input className="form-control" name="kode_role" value={editData.kode_role} disabled />
                </div>
                <div className="form-group">
                  <label>Kode Hal</label>
                  <input className="form-control" name="kode_hal" value={editData.kode_hal} disabled />
                </div>
                <div className="form-group form-check">
                  <input
                   type="checkbox"
                   className="form-check-input"
                   name="status"
                   checked={editData.status === true}
                   onChange={(e) => handleChange(e, true)}
                  />
                  <label className="form-check-label">Aktif</label>
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setModalEditOpen(false)}>Tutup</button>
                <button className="btn btn-primary" onClick={handleEdit}>Simpan</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  </div>

  );
};

export default ListRoleHalaman;
